
import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import ItemsSearchDialog from '../../components/Field/ItemsSearchDialog.vue'

export default {
  name: 'ServiceObjectPropertyAdjacentParentsNew',
  extends: CardPropertyObjectTable,
  data: function () {
    let componentProps = this.tabProp.componentProps
    if (!componentProps) {
      componentProps = {}
      this.$set(this.tabProp, 'componentProps', componentProps)
    }
    this.$set(this.tabProp.componentProps, 'hideHeader', false)
    this.$set(this.tabProp.componentProps, 'fulltext', true)

    return {
      selectFn: this.onShowSelectionDialog // @Override
    }
  },
  computed: {
    columns: function () {
      const columns = []
      columns.push(this.getColumnConfig({
        name: 'parentName',
        label: 'Смежный объект (корневой)',
        type: 'string',
        componentProps: { groupByColumn: true }
      }))
      columns.push(this.getColumnConfig({
        name: 'name',
        label: 'Группа объектов, смежных с корневым',
        type: 'string',
        format: val => {
          const row = this.rows.find(row => row.name === val)
          return row.parentAdjacentObjects.length > 1 ? `${val} (+)` : val
        },
        sort: (a, b, rowA, rowB) => {
          if (rowA.parentId === rowB.parentId) {
            return a.localeCompare(b)
          }
          return 0
        },
        componentProps: {
          tooltip: (row, val) => {
            return row.parentAdjacentObjects.length
              ? `Смежные объекты (корневые):
            ${row.parentAdjacentObjects.map((adjacent) => {
              return adjacent.name
            }).join('\n')}` : 'Нет смежных корневых объектов'
          },
          tdStyle: (val, row) => {
            return row.currentObject ? 'color: #0000FF' : ''
          },
          noExtraFormat: true
        }
      }))
      columns.push(this.getColumnConfig({
        name: 'viewObjectDistanceText',
        label: 'Расстояние от текущего объекта (по прямой)',
        componentProps: {
          noExtraFormat: true,
          tdStyle: (val, row) => {
            return row.currentObject ? 'background-color: #F0F0F0; white-space: pre-line;' : 'white-space: pre-line;'
          }
        },
        sort: (a, b, rowA, rowB) => {
          if (rowA.parentId === rowB.parentId) {
            return parseFloat(a) - parseFloat(b)
          }
          return 0
        },
        format: val => {
          const row = this.rows.find(row => row.viewObjectDistanceText === val)
          return !row.currentObject ? val : null
        },
        type: 'string'
      }))
      columns.push(this.getColumnConfig({
        name: 'parentObjectDistanceText',
        label: 'Расстояние от корневого объекта (по прямой)',
        type: 'string',
        componentProps: {
          tdStyle: (val, row) => {
            return row.currentObject ? 'background-color: #abe6ff; white-space: pre-line;' : 'white-space: pre-line;'
          }
        },
        sort: (a, b, rowA, rowB) => {
          if (rowA.parentId === rowB.parentId) {
            return parseFloat(a) - parseFloat(b)
          }
          return 0
        }
      }))
      return columns
    },
    serviceObject: function () {
      return (this.object && this.object._serviceObject) || null
    },
    adjacentParents: function () {
      return this.serviceObject && this.serviceObject.adjacentParents
    },
    rows: function () {
      const rows = []
      let adjacentParents = []
      if (this.object && this.object._serviceObject) {
        adjacentParents = this.object._serviceObject.adjacentParents || []
      } else if (this.object) {
        adjacentParents = this.object.adjacentParents || []
      }
      adjacentParents.forEach(adjacentParent => {
        if (adjacentParent.adjacentChildren) {
          adjacentParent.adjacentChildren.forEach(adjacentChild => {
            const row = {
              parentId: adjacentParent.id,
              parentName: adjacentParent.name,
              parentKey: adjacentParent.key,
              parentType: adjacentParent.type
            }
            Object.keys(adjacentChild).forEach(key => {
              if (key !== 'adjacentChildren') {
                row[key] = adjacentChild[key]
              }
            })
            rows.push(row)
          })
        }
      })
      return rows
    }
  },
  methods: {
    // @Override
    onShowSelectionDialog: function () {
      this.$q.dialog({
        component: ItemsSearchDialog,
        parent: this,
        config: {
          headerLabel: this.componentProps.dialogLabel,
          value: this.object[this.tabProp.key],
          store: this.objectFieldConfig.store,
          multiple: true, // TODO this.multiple
          onApply: items => {
            this.object[this.tabProp.key] = items
            items.forEach(item => {
              if (!this.object._serviceObject.adjacentParents.find(adjacent => adjacent.id === item.id)) {
                const adjacentChildren = this.object._serviceObject.adjacentParents.length
                  ? [this.object._serviceObject.adjacentParents[0].adjacentChildren.find(adjacent => adjacent.id === this.serviceObject.id)]
                  : [{
                    id: this.serviceObject.id,
                    name: this.serviceObject.name,
                    key: this.serviceObject.key,
                    type: this.serviceObject.type,
                    parentAdjacentObjects: {
                      id: item.id,
                      name: item.name,
                      key: item.key,
                      type: item.type
                    }
                  }]
                this.object._serviceObject.adjacentParents.push({
                  id: item.id,
                  name: item.name,
                  key: item.key,
                  type: item.type,
                  adjacentChildren: adjacentChildren
                })
              }
            })
          }
        }
      })
    },

    // @Override
    onDeleteRow: function (row) {
      const index = this.object[this.tabProp.key].findIndex(adjacent => adjacent.id === row.parentId)
      if (index !== -1) {
        this.object[this.tabProp.key].splice(index, 1)
      }
      const adjacentParentIndex = this.object._serviceObject.adjacentParents.findIndex(adjacent => adjacent.id === row.parentId)
      if (adjacentParentIndex !== -1) {
        this.object._serviceObject.adjacentParents.splice(index, 1)
      }
    },

    // @Override
    onRowClick: function (event, row) {
      const componentProps = this.tabProp.componentProps
      if (!componentProps.showRelationship) {
        /**
         * Для корректного срабатывания перехода в карточку объекта по клику на строку таблицы
         * проверяем, по какой колонке кликнули, и передаем showObjectCard row с нужным id и type,
         * так как в общем row хранятся данные и дочернего, и родительского объекта
         *  */
        const clickedVueInstance = event.target.__vue__
        const parentVueInstance = event.target.parentNode.__vue__
        if (clickedVueInstance && clickedVueInstance.$vnode.key === 'parentName' || parentVueInstance && parentVueInstance.$vnode.key === 'parentName') {
          this.showObjectCard(event, { id: row.parentId, type: row.parentType })
        } else {
          this.showObjectCard(event, { id: row.id, type: row.type })
        }
      }
      this.$emit('row-click', {
        row,
        index: this.rows.indexOf(row),
        event
      })
    }
  }
}
